import * as React from "react";
import styled from "styled-components";
import { LINKS } from "../../../consts/links";
import { ButtonAction } from "../../Button";
import { PhoneNoPhone } from "../../PhoneNoPhone/PhoneNoPhone";
import { TRACKING_CODES } from "../../../consts/trackingCodes";
import { BorderedNavLink } from "../NavLink";
import { HelpOutlineIcon } from "../../Svg/HelpOutline";
import { BREAK_POINTS } from "../../../consts/style";
import { Search as SearchIcon } from "../../Svg/Search";
import { PersonOutline as PersonOutlineIcon } from "../../Svg/PersonOutline";
import { LinkProps } from "../../Link";

const AccountNavContainer = styled.div`
  display: flex;
  a.active,
  a:hover span {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

const MyAccountLink = styled(BorderedNavLink)`
  cursor: pointer;
  color: ${(p) => p.theme.colors.grey300};
  & > svg {
    fill: ${(p) => p.theme.colors.grey300};
  }
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    && {
      height: 48px;
      padding: 14px 20px;

      > svg {
        right: 10px;
      }
    }
  }
  border-right: 0;
`;

interface MyAccountLinkLoginProps extends LinkProps {
  theme?: any;
}

export const MyAccountLinkLogin = styled(MyAccountLink)`
  > svg {
    fill: ${(p: MyAccountLinkLoginProps) => p.theme.colors.primary};
  }
  /* stylelint-disable-next-line */
  > span {
    color: ${(p: MyAccountLinkLoginProps) => p.theme.colors.primary};
  }

  &:hover {
    > svg {
      fill: ${(p: MyAccountLinkLoginProps) => p.theme.colors.primaryDark};
    }
    /* stylelint-disable-next-line */
    > span {
      color: ${(p: MyAccountLinkLoginProps) => p.theme.colors.primaryDark};
    }
  }
`;

const IconLink = styled(BorderedNavLink)`
  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    && {
      height: 48px;
      padding: 14px 20px;
      > svg {
        right: 5px;
        top: 0;
      }
    }
  }
`;

const IconLinkBoardLeft = styled(IconLink)`
  @media (max-width: ${BREAK_POINTS.MAX.LG}) {
    border-left: 1px solid ${(p) => p.theme.colors.grey200};
  }
`;

export interface IAnchor {
  href?: string;
  text?: string;
}

export const AccountNav = (props: IAnchor) => (
  <AccountNavContainer>
    {props.href && props.text && (
      <PhoneNoPhone
        width={BREAK_POINTS.MIN.LG}
        phone={null}
        noPhone={
          <ButtonAction
            href={props.href}
            data-id={TRACKING_CODES.SEE_OUR_PLANS}
          >
            {props.text}
          </ButtonAction>
        }
      />
    )}
    <IconLinkBoardLeft
      href={LINKS.HEADER.HELP_AND_SUPPORT}
      data-id={TRACKING_CODES.HELP}
      trackingType="navDesktopHelp"
    >
      <HelpOutlineIcon />
      <span>Help</span>
    </IconLinkBoardLeft>
    <IconLink
      href={LINKS.HEADER.SEARCH}
      data-id={TRACKING_CODES.SEARCH}
      trackingType="navDesktopSearch"
    >
      <SearchIcon />
      <span>Search</span>
    </IconLink>
    <MyAccountLinkLogin
      trackingType="navDesktopMyAccountLogin"
      href={LINKS.HEADER.LOGIN}
      data-id={TRACKING_CODES.LOGIN}
    >
      <PersonOutlineIcon />
      <span>Log in</span>
    </MyAccountLinkLogin>
  </AccountNavContainer>
);
